import type { HelperOptions } from 'handlebars';
import Handlebars from 'handlebars';

Handlebars.registerHelper(
  'ifEquals',
  function (this: any, arg1: any, arg2: any, options: HelperOptions) {
    return (arg1 == arg2)
      ? options.fn(this)
      : options.inverse(this)
    ;
  },
);

function mandrillToHandlebars(template: string): string {
  const regex = new RegExp('{{#if `((?:(?! == ).)*) == ((?:(?!`}}).)*)`}}((?:(?!{{\\/if}}).)*){{\\/if}}', 'gs');

  return template
    .replace(regex, '{{#ifEquals $1 $2}}$3{{/ifEquals}}')
  ;
}

export function renderMandrillTemplate(template: string, data: Record<string, any>): string {
  const compiler = Handlebars.compile(mandrillToHandlebars(template), { noEscape: true });

  return compiler(data);
}
